/**
 * Maps Supabase Auth (and similar) English errors to i18n keys under auth.errors.*
 */
export function mapAuthErrorToKey(raw) {
  const lower = String(raw || '')
    .trim()
    .toLowerCase();
  if (!lower) return 'auth.errors.generic';
  if (lower.includes('invalid login') || lower.includes('invalid credentials')) {
    return 'auth.errors.invalidCredentials';
  }
  if (
    lower.includes('already registered') ||
    lower.includes('user already') ||
    lower.includes('email address is already') ||
    lower.includes('already exists') ||
    lower.includes('duplicate key') ||
    lower.includes('unique constraint')
  ) {
    return 'auth.errors.emailTaken';
  }
  if (lower.includes('email not confirmed')) {
    return 'auth.errors.emailNotConfirmed';
  }
  if (lower.includes('password') && (lower.includes('least') || lower.includes('6'))) {
    return 'auth.errors.weakPassword';
  }
  if (lower.includes('network') || lower.includes('fetch') || lower.includes('failed to fetch')) {
    return 'auth.errors.network';
  }
  if (
    lower.includes('provider is not enabled') ||
    lower.includes('unsupported provider') ||
    lower.includes('validation_failed')
  ) {
    return 'auth.errors.providerDisabled';
  }
  return 'auth.errors.generic';
}
